module.exports = __webpack_public_path__ + "assets/logo-white.d1ddcf3c.svg";